<template>
	<div
		class="flex items-center pt-1 text-xs text-error"
		:[dataTestErrorName]="''"
		:class="{ 'pl-4': !noIndent }"
		aria-live="polite"
	>
		<SvgIcon v-if="errorMessage?.trim()" icon-name="error" title="Fehler:" class="mr-1 size-4 shrink-0" />
		{{ errorMessage }}
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import SvgIcon from "../SvgIcon/SvgIcon.vue";

const props = defineProps<{
	errorMessage: string | undefined;
	noIndent?: boolean;
	dataTestName?: string;
}>();

const dataTestErrorName = computed(() => (props.dataTestName ? `${props.dataTestName}-error` : ""));
</script>
